module.exports = __webpack_public_path__ + "img/banner afbeelding program overview.18733e71.jpg";